require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./physique-et-physique-applique-2-2-2-10.json") })
        }
      }, "path---physique-et-physique-applique-2-2-2-10");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---physique-et-physique-applique-2-2-2-10!./.cache/json/physique-et-physique-applique-2-2-2-10.json
// module id = 522
// module chunks = 231608221292675